import * as React from 'react';

function Profile({data} :any) {

  function displayWebsite(url, desc) {
    if (url !== " " && url !== null) {
      return (
        <a href={url} target='_blank'>{' ' + desc + '.'}</a>
      )
    } else {
      return (<span/>)
    }
  }

  return (
    <div className="col-lg-4 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">{data.company_name}</h4>
          <p className="card-description">{data.profile?.industry_group || data.industry }. {displayWebsite(data.profile?.wikipedia_page, 'Wikipedia')}{displayWebsite(data.profile?.website, data.profile?.website)}
          </p>
          <div className="table-responsive">
            <table className="table table-striped">
              <tbody>
                <tr>
                  <td>Market Cap</td>
                  <td>{data.market_cap}</td>
                </tr>
                <tr>
                  <td>PE Ratio (ttm)</td>
                  <td>{data.pe_ratio}</td>
                </tr>
                <tr>
                  <td>EPS (ttm)</td>
                  <td>{data.ttm_eps}</td>
                </tr>
                <tr>
                  <td>Dividend Yield ttm (%)</td>
                  <td>{data.dividend_yield}</td>
                </tr>
                <tr>
                  <td>Payout Ratio ttm (%)</td>
                  <td>{data.payout_ratio_ttm}</td>
                </tr>
                <tr>
                  <td>Earnings Date</td>
                  <td>{data.next_earnings_date}</td>
                </tr>
                {data.exchange && (
                  <tr>
                    <td>Exchange</td>
                    <td>{data.exchange}</td>
                  </tr>
                )}
                {data.exchange_currency && (
                  <tr>
                    <td>Exchange Currency</td>
                    <td>{data.exchange_currency}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;